import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'

import StateIcon from './global/StateIcon'


const IconText = ({ icon, color, iconweight, iconsize, fontSize, children }) => {
  const theme = useTheme()
  if (!children) {
    return null
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        color,
        gap: theme.spacing(0.5),
        width: 'fit-content'
      }}
    >
      <StateIcon
        iconlabel={icon}
        iconcolor={color || '#BDBDBD'}
        iconweight={iconweight || 'regular'}
        iconsize={iconsize || '12px'}
      />
      <Typography
        sx={{
          textWrap: 'nowrap',
          fontSize : fontSize || '12px',
          color: color || '#424242',
          fontWeight: 300,
        }}>
        {children}
      </Typography>
    </Box>
  )
}

export default IconText
